/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
import React from "react";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import {
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

export default function DocTableHead({ classes, handleOpen, index, name }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <TableHead
      onClick={handleOpen}
      style={{
        cursor: "pointer",
      }}
    >
      <TableRow>
        <TableCell className={classes.headCells} width={isMobile ? 30 : 60}>
          <Typography variant="h5" className={classes.t1} align="center">
            {index}
          </Typography>
        </TableCell>
        <TableCell className={classes.headCells}>
          <Typography variant="h5" className={classes.t1}>
            {name}
          </Typography>
        </TableCell>
        <TableCell
          className={classes.headCells}
          width={isMobile ? 100 : 200}
          align="center"
        >
          <Typography variant="h5" className={classes.t1}>
            تاریخ بارگذاری فایل
          </Typography>
        </TableCell>
        <TableCell
          colSpan={1}
          className={classes.headCells}
          width={isMobile ? 30 : 60}
        >
          <ExpandMoreOutlinedIcon className={classes.iconArrow} />
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
